// extracted by mini-css-extract-plugin
export var closed = "_az-1";
export var resizer = "_az-0";